import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig, initSentry } from '@app/app/app.config';
import { AppComponent } from '@app/app/app.component';

initSentry();
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
